export default __webpack_public_path__ + "static/media/briefcase.4438696b.svg";